import React from 'react'
import Layout from '../components/Layout'
import * as styles from '../styles/private-events.module.scss'
import { graphql } from 'gatsby'
import { getImage } from 'gatsby-plugin-image'
import Header from '../components/Header'
import VerveH1 from '../components/VerveH1'

export default function PrivateEvents({ data }) {

  const banner = getImage(data.banner)
  
  return (
    <Layout pageTitle="Private Events">
      <Header imageData={banner} bgClass={styles.header_bg}>
        <VerveH1 h1="Private Events"/>
      </Header>
      <section className={styles.private_events_list} id="main">
        <div className="container">
          <div className={styles.events_list}>
            <ul>
              <li>corporate events</li>
              <li>wedding rehearsals</li>
              <li>business luncheons</li>
              <li>birthday parties</li>
            </ul>
            <ul>
              <li>baby showers</li>
              <li>school functions</li>
              <li>wedding showers</li>
              <li>personal celebrations</li>
            </ul>
          </div>
        </div>
      </section>
      <section className={styles.private_events_form}>
        <div className="container">
          <div className={styles.event_intro}>
            <h2>Tell us about your party.</h2>
            <p>We'll be in touch soon.</p>
          </div>
          <form 
            name="events"
            // action="/contact/success" - redirect here after form submission
            method="POST"
            data-netlify="true"
            netlify-honeypot="bot-field"
            data-netlify-recaptcha="true"
          >
            <span class={styles.hidden}>
              <label>
                Don’t fill this out if you’re human: <input name="bot-field" />
              </label>
            </span>          
            <span>
              <label className={styles.required} htmlFor="name">Name: </label>
              <input type="text" name="name" id="name" required />
            </span>
            <span>
              <label htmlFor="occasion">Occasion: </label>
              <input type="text" name="occasion" id="occasion" />
            </span>
            <span>
              <label className={styles.required} htmlFor="people">How many people you wanna squeeze in here? </label>
              <input type="text" name="people" id="people" required />
            </span>
            <span>
              <label className={styles.required} htmlFor="date">Date of Event: </label>
              <input type="date" name="date" id="date" required />
            </span>
            <span>
              <label className={styles.required} htmlFor="time">Time of Event: </label>
              <input type="time" name="time" id="time" required />
            </span>
            <span>
              <label className={styles.required} htmlFor="email">Email: </label>
              <input type="email" name="email" id="email" required />
            </span>
            <span>
              <label htmlFor="phone">Phone: </label>
              <input type="tel" name="phone" id="phone" />
            </span>
            <span>
              <label htmlFor="comments">Anything else you want us to know?</label>
              <textarea name="comments" id="comments" rows="10" />
            </span>
            <span className={styles.form_footer}>
              <div data-netlify-recaptcha="true"></div>
              <button className="button_slide" type="submit">Send</button>
            </span>
          </form>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    banner: file(relativePath: {eq: "verve_interior_ceiling.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: BLURRED
        )
      }
    }
  }
`;